<template>
  <div>
    <multiselect
          v-if="!activeLocation && menus.length > 1"
          v-model="selectedMenu"
          track-by="id"
          label="name"
          :options="menus"
          :multiple="false"
          :show-labels="false"
          :allow-empty="false"
          :searchable="menus.length > 5"
          title="Select Menu to Configure"
          placeholder="Select Menu"
          @select="changeMenu"
          />
    <input class="form-control" v-else readonly
          :value="selectedMenu ? selectedMenu.name : 'No Menu Selected'" />
  </div>
</template>

<script>
import { settingsFactoryMixin } from '@/common/mixins/settings-factory-mixin'
import userInfoMixin from '@/common/mixins/user-info-mixin'
import menuService from '@/menu/menu-service'
import { mapState } from 'vuex'

export default {
  name: 'menu-selector',
  mixins: [userInfoMixin, settingsFactoryMixin],
  data () {
    return {
      selectedMenu: null,
      menus: []
    }
  },
  mounted () {
    this.loadMenus()
  },
  computed: {
    ...mapState('login', ['activeLocation'])
  },
  methods: {
    loadMenus () {
      this.selectedMenu = null
      return menuService.getCompanyMenus(this.userCompanyId)
        .then(menus => {
          this.menus = menus
          if (this.getSettingsFactory().menuId) {
            this.selectedMenu = this.menus.find(menu => menu.id === this.getSettingsFactory().menuId)
          }
        })
        .catch(error => {
          this.handleError(error, 'Unable to retrieve Menu Information')
        })
    },
    changeMenu (menu) {
      const query = {
        menuId: menu.id,
        locationId: this.activeLocation ? this.activeLocation.id : null
      }
      this.$router.push({
        name: 'changeMenu',
        query: query
      }).catch(() => {})
    }

  }
}
</script>
